"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpEditAssessment = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Constants_1 = require("../../Constants");
var learnosity_1 = require("../../../api/learnosity");
var DpEditAssessment_styled_1 = require("./DpEditAssessment.styled");
/**
 * This component renders the learnosity edit assessment functionality.
 * Every event related to the component should be registered here.
 *
 * Reference: https://reference.learnosity.com/data-api
 */
var DpEditAssessment = function (_a) {
    var signedRequest = _a.signedRequest, initHandler = _a.initHandler, saveHandler = _a.saveHandler, activityVisibilityChangeHandler = _a.activityVisibilityChangeHandler, activityRenderHandler = _a.activityRenderHandler;
    (0, react_1.useEffect)(function () {
        var lrnApi = window[Constants_1.LEARNOSITY_AUTHOR_API];
        var lrnApp = lrnApi.init(signedRequest, {
            errorListener: function (e) {
                console.log(e);
            },
            readyListener: function () {
                var authorApp = new learnosity_1.AuthorApp(lrnApp);
                if (initHandler) {
                    initHandler(authorApp);
                }
                // Enable only for debugging purposes
                // lrnApp.on('all', (type: any) => {
                //   console.log(type);
                // });
                lrnApp.on('render:itemlist', function (event) {
                    activityVisibilityChangeHandler(false);
                });
                lrnApp.on('open:activity', function (event) {
                    activityVisibilityChangeHandler(true);
                });
                lrnApp.on('render:activity', function (event) {
                    if (activityRenderHandler)
                        activityRenderHandler();
                });
                lrnApp.on('save:activity:success', function () {
                    if (saveHandler) {
                        saveHandler();
                    }
                });
                lrnApp.on('save:activity:error', function () {
                    if (saveHandler) {
                        saveHandler(true);
                    }
                });
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [signedRequest]);
    return (0, jsx_runtime_1.jsx)(DpEditAssessment_styled_1.StyledEditAssessment, { id: "learnosity-author" });
};
exports.DpEditAssessment = DpEditAssessment;
